export default __webpack_public_path__ + "7f199fdb6f3aec3e4cd3b97c5dee5595.png";